<template>
    <div class="page">
    <div class="d-flex justify-content-center align-items-center">
      <div class="container">
        <div class="row" style="margin-top:50px">
          <div class="col-lg-6 offset-lg-3 col-md-12 mb-4">
            <div>
              <div class="register col-lg-12 col-sm-12">
                 <!-- Generate button -->
                  <!-- Full Name & Instansi Information -->
                  <div class='content' style="background-color:white">
                    <div class="container" style="padding-top:5%; padding-bottom:5%">
                        <h4>Login</h4>
                        <input type="text" v-model="username" autocomplete="off" class="form-control mt-4" placeholder="Username" required>
                        <input type="password" v-model="password" autocomplete="off" class="form-control mt-4" placeholder="Password" required>
                        <button class="btn btn-login btn-rounded btn-block my-4 waves-effect z-depth-0" @click='login'>Login</button>
                    </div>
                  </div>
                <div id="code" class="code"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config.js'
export default {
    props : ['checkLogin', 'getGuestData', 'getReportData'],
    data: function(){
        return{
            username : '',
            password : ''
        }
    },
    created : function(){
        let token = localStorage.getItem('token')
        if(token){
            this.$router.push({ name : 'home' })
        }
    },
    methods : {
        login(){
            axios({
                method : 'POST',
                url : `${config.port}/users/login`,
                data : {
                    username : this.username,
                    password : this.password
                }
            })
            .then(response => {
                console.log(response.data)
                localStorage.setItem('token', response.data.token)
                localStorage.setItem('bride', response.data.bride)
                localStorage.setItem('groom', response.data.groom)
                localStorage.setItem('user', response.data.username)
                localStorage.setItem('status', response.data.status)
                this.checkLogin()
                this.username = ''
                this.password = ''
                this.$router.push({
                    path : '/'
                })
                this.getGuestData()
                this.getReportData()
            })
            .catch(err => {
                console.log(err)
            })
        }
    }

}
</script>

<style scoped>
   html,body{height:100%}
  .navbar{background-color:#fff}
  .page{height:100vh;background-image:url("https://cdn.hipwallpaper.com/m/68/48/sFjrMW.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");background-repeat:no-repeat;background-size:cover;; padding-top:70px}
  .page .mask{height:100vh}
  .page__title{font-size:2rem;color:#fff;margin:1rem 0;text-align:center;text-transform:uppercase}
  .page__name{font-size:1.5rem;margin-bottom:1rem}
  .page__date,.page__location{font-size:1rem}
  .page__note{position:fixed;bottom:20px;right:20px;color:#fff}
  .page__note a{color:#fff;font-weight:bold}.card{position:relative;overflow:hidden}
  .card video{width:100%;height:400px;object-fit:cover;border-radius:4px}
  .card .scanning::before{content:"";position:absolute;top:50%;left:50%;width:300px;height:300px;border:1px solid #fff;transform:translate(-50%, -50%);z-index:200}
  .card .scanning::after{content:"";position:absolute;top:0;left:0;width:100%;height:30px;background-image:linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8));animation:scanning 3s linear infinite}@keyframes scanning{100%{top:100%}}/*# sourceMappingURL=style.min.css.map */

  .btn-login{
      background-color: #f8964d;
  }
</style>
